"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arkReact = require("@dateam/ark-react");
var _ark = require("@dateam/ark");
var _MenuContext = _interopRequireDefault(require("./MenuContext"));
const MenuItem = _ref => {
  let {
    index,
    className,
    disable,
    children,
    onClick
  } = _ref;
  const {
    hoverIndex,
    hoverIndexDispatch
  } = _react.default.useContext(_MenuContext.default);
  const handleMouseEnter = () => {
    if ((0, _ark.isFunction)(hoverIndexDispatch)) {
      hoverIndexDispatch({
        index: index ?? 0
      });
    }
  };
  const handleMenuItemClick = _react.default.useCallback(event => {
    if (disable !== true && (0, _ark.isFunction)(onClick)) {
      onClick(event);
    }
  }, [disable, onClick]);
  return /*#__PURE__*/_react.default.createElement("li", {
    role: "menuitem",
    onMouseEnter: handleMouseEnter,
    className: (0, _arkReact.concatClassName)('menuItem', disable === true ? 'menuItem-disable' : null, hoverIndex === index ? 'menuItem-active' : null, className),
    onClick: handleMenuItemClick
  }, children);
};
process.env.NODE_ENV !== "production" ? MenuItem.propTypes = {
  index: _propTypes.default.number,
  className: _propTypes.default.string,
  disable: _propTypes.default.bool,
  children: _propTypes.default.node,
  onClick: _propTypes.default.func
} : void 0;
MenuItem.defaultProps = {
  index: undefined,
  className: undefined,
  disable: undefined,
  children: undefined,
  onClick: undefined
};
var _default = exports.default = MenuItem;